import { Injectable, ViewContainerRef } from '@angular/core';
import { Response} from '@angular/http';
import { AuthHttp } from 'angular2-jwt';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import { AuthGuard } from '../auth/auth.guard';
import { Router } from '@angular/router';
import { PopupService } from '../shared/popup/popup.service';
@Injectable()
export class ApiService {
    constructor(protected http: AuthHttp, private router: Router, private popupService: PopupService) {
    }

    /*
      Extract JSON Object from Response
    */
    protected extractData(res: Response) {
      return { status: res.status , data: res.json() || ''};
    }

    /*
      The Error Handler from HTTP
    */
  protected handleError(error: Response): any {
    this.handleErrors(error);
    // lets handle 401 only from this file,
    // don't call this function if you want to handle by yourself
    if (error.status !== 401) {
      return Observable.throw(error);
    }
  }

  private extractErrorMessage(error: Response) {
    try {
      return error.json().errors;
    } catch (e) {
      return 'Sorry, You are not authorized to view this content.';
    }
  }

  private handleErrors(error: Response) {
    const errors = this.extractErrorMessage(error);
    const { status } = error;
    if (status === 401) {
      this.handleUnauthorizedResponse(errors);
    }
  }

  private handleLogout = () => {
    AuthGuard.logout();
    this.router.navigate(['/authenticate/logout']);
  }

  private handleUnauthorizedResponse(errors: string) {
    this.popupService.data = {
      title: 'Unauthorized Access',
      popupMessage: `Oops! ${errors}`,
      okTitle: 'Ok'
    };
    this.popupService.cancelCallback = this.handleLogout;
    this.popupService.confirmCallback = this.handleLogout;
    this.popupService.showPopup$.next(true);
  }

}



// WEBPACK FOOTER //
// ./src/app/api/api.service.ts